import { unset } from 'lodash';

const DialogEditCompanyOrganizerStyle = (theme) => ({
    items: {
        margin: '30px 0 15px 0',
        display: 'flex',
        alignContent: 'baseline',
        '& p': {
            margin: '8px 0 8px 0',
        },
    },

    lineInput: {
        padding: '0px 15px 0px 0px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px',
            marginBottom: '15px',
        },
    },

    leftTitle: {
        // margin: '15px',
    },

    btn: {
        width: '100%',
        display: 'flex',
    },

    rightInput: {
        marginLeft: '-75px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
        },
    },

    image: {
        marginTop: '8px',
        maxWidth: '300px',
        maxHeight: '300px',
        borderRadius: '10px',
    },

    maxHeight: {
        width: '650px',
        '& td,th': {
            padding: '0px 16px',
        },
    },

    paymentField: {
        paddingLeft: '0px',
        pointerEvents: 'none',
    },

});

export default DialogEditCompanyOrganizerStyle;
